import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentsSidebarFilterCategory from './VeltCommentsSidebarFilterCategory/VeltCommentsSidebarFilterCategory';
import VeltCommentsSidebarFilterCloseButton from './VeltCommentsSidebarFilterCloseButton/VeltCommentsSidebarFilterCloseButton';
import VeltCommentsSidebarFilterCommentType from './VeltCommentsSidebarFilterCommentType/VeltCommentsSidebarFilterCommentType';
import VeltCommentsSidebarFilterDoneButton from './VeltCommentsSidebarFilterDoneButton/VeltCommentsSidebarFilterDoneButton';
import VeltCommentsSidebarFilterGroupBy from './VeltCommentsSidebarFilterGroupBy/VeltCommentsSidebarFilterGroupBy';
import VeltCommentsSidebarFilterLocation from './VeltCommentsSidebarFilterLocation/VeltCommentsSidebarFilterLocation';
import VeltCommentsSidebarFilterPeople from './VeltCommentsSidebarFilterPeople/VeltCommentsSidebarFilterPeople';
import VeltCommentsSidebarFilterPriority from './VeltCommentsSidebarFilterPriority/VeltCommentsSidebarFilterPriority';
import VeltCommentsSidebarFilterTitle from './VeltCommentsSidebarFilterTitle/VeltCommentsSidebarFilterTitle';
import VeltCommentsSidebarFilterVersions from './VeltCommentsSidebarFilterVersions/VeltCommentsSidebarFilterVersions';
import VeltCommentsSidebarFilterItem from './VeltCommentsSidebarFilterItem/VeltCommentsSidebarFilterItem';
var VeltCommentsSidebarFilter = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-wireframe", __assign({}, remainingProps), children));
};
VeltCommentsSidebarFilter.Category = VeltCommentsSidebarFilterCategory;
VeltCommentsSidebarFilter.CloseButton = VeltCommentsSidebarFilterCloseButton;
VeltCommentsSidebarFilter.CommentType = VeltCommentsSidebarFilterCommentType;
VeltCommentsSidebarFilter.DoneButton = VeltCommentsSidebarFilterDoneButton;
VeltCommentsSidebarFilter.GroupBy = VeltCommentsSidebarFilterGroupBy;
VeltCommentsSidebarFilter.Location = VeltCommentsSidebarFilterLocation;
VeltCommentsSidebarFilter.People = VeltCommentsSidebarFilterPeople;
VeltCommentsSidebarFilter.Priority = VeltCommentsSidebarFilterPriority;
VeltCommentsSidebarFilter.Title = VeltCommentsSidebarFilterTitle;
VeltCommentsSidebarFilter.Versions = VeltCommentsSidebarFilterVersions;
VeltCommentsSidebarFilter.Item = VeltCommentsSidebarFilterItem;
export default VeltCommentsSidebarFilter;
